import { useEffect } from 'react'
import { useLocation } from 'react-router'

export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const targetId = decodeURIComponent(hash.slice(1))
      if (!targetId) return

      let attempts = 0
      const maxAttempts = 30
      const interval = setInterval(() => {
        const target = document.getElementById(targetId)
        attempts += 1

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' })
          clearInterval(interval)
          return
        }

        if (attempts >= maxAttempts) {
          clearInterval(interval)
        }
      }, 80)

      return () => clearInterval(interval)
    }

    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname, hash])

  return null
}